import { useContext, useEffect, useState } from "react";
import { Button, Card, Col, Form, OverlayTrigger, Row, Tooltip } from "react-bootstrap";
import { CalendarIconSvg, InfoIconSvg, MoonIconSvg, OneWayTripIconSvg, RoundTripIconSvg, ShipIconSvg, UserIconSvg } from "../../../../assets/svg";
import { ExclamationIconSvgPPP } from "../../../PublicPaymentPage/components/svgImages";
import { splitDate } from "../../../../utils/splitDate";
import SpecialAddon from "./SpecialAddon";
import ModalWrapper from "../../../../components/ModalWrapper/ModalWrapper";
import PriceDetailModal from "../../../../components/Modals/PriceDetailModal/PriceDetailModal";
import ItinerarySuccessModal from "../../../../components/Modals/ItinerarySuccessModal/ItinerarySuccessModal";
import SnackbarContext from "../../../../context/snackbar.context";
import dayjs from "dayjs";

const PriceDetail = ({ show, payloadObj, netPrice, setStepNumber, setPayloadObj, viewDetail=false, itineraryDetails, clx , specialPricingUpgradeOffer, discountDescription = ''}: any) => {
  const snackbarCtx = useContext(SnackbarContext);
  const [successModalState, setSuccessModalState] = useState<boolean>(false);
  const [priceModalState, setPriceModalState] = useState<boolean>(false);
  const [currentItineraryDetails, setCurrentItineraryDetails] = useState<any>({});

  const handlePreviewQuotation = async () => {
    if (!payloadObj?.rooms?.length) {
      snackbarCtx.toggleSnackbar({
        message: 'Please add guests first!',
        type: 'FAILURE',
        visible: true,
        });
      return;
    } else if (payloadObj?.roomSelectionType === 'agent_selection' && payloadObj?.rooms.some((room: any) => !room?.selectedRoom?.deck_no || !room?.selectedRoom?.room_number)) {
      snackbarCtx.toggleSnackbar({
        message: 'Please select deck and room for all selected cabins!',
        type: 'FAILURE',
        visible: true,
        });
      return;
    }
    setPriceModalState(true);
  };
  
  useEffect(() => {
    if (!!itineraryDetails?.length) {
      const tempArr = itineraryDetails.find((data: any) => data.value === payloadObj?.itineraryId);
      setCurrentItineraryDetails({ ...tempArr });
    }
  }, [payloadObj?.itineraryId]);

  const handleGuestCount = () => {
    const guestsInfo = { count: 0, adults: 0, children: 0, infants: 0 };
    payloadObj?.rooms?.reduce((acc: any, room: any) => {
      const adults = room?.guests?.adults || 0;
      const children = room?.guests?.children || 0;
      const infants = room?.guests?.infants || 0;
      const totalCount = adults + children + infants;
  
      acc.count += totalCount;
      acc.adults += adults;
      acc.children += children;
      acc.infants += infants;
  
      return acc;
    }, guestsInfo);
    return guestsInfo;
  };

  const handleTripType = (tripType: string) => {
    return tripType?.includes('one') ? 'One Way Trip' : 'Round Trip';
  }

  return (
    <Card className={`border h-100 ${clx}`} style={{ marginTop: viewDetail === true ? 0:20 }}>
      <Card.Body>
        <span className="pb-3 font-semibold text-2xl text-[#3a3a3a]">PRICE DETAILS</span>
        {!show && (
          <Row className="mt-2">
            <Col xs={12} sm={6}>
              <Form.Text className="input-label price-text">Cabin Price</Form.Text>
            </Col>
            <Col xs={12} sm={6}>
              <Form.Text className="input-label select-guest mt-0 flex justify-end">
                <ExclamationIconSvgPPP/>
                Select Guests & Cabin
              </Form.Text>
            </Col>
          </Row>
        )}
        {show && !!netPrice?.cabin_names?.length &&
          netPrice?.cabin_names?.map((data: any, index: number) => {
            return (
              <Row key={index} className={index === 0 ? `mt-2` : ''}>
                <Col xs={12} sm={6}>
                  <Form.Text className="input-label price-text">{netPrice?.cabin_names[index]}</Form.Text>
                </Col>
                <Col xs={12} sm={6}>
                  <Form.Text className="input-label price-text invoice ">
                    ₹{new Intl.NumberFormat("en-IN").format(Math.round(netPrice?.cabin_fares[index]))}
                  </Form.Text>
                </Col>
              </Row>
            );
          })}
        <Row>
          <Col xs={12} sm={6} className="flex flex-col">
            <Form.Text className="input-label ">Service Tax & Levies</Form.Text>
            {/* {show && !!netPrice?.port_charges && <Form.Text className="input-label port-text-font">(Port Charges + Gratuity)</Form.Text>} */}
          </Col>
          <Col xs={12} sm={6} className="items-start invoice">
            <Form.Text className="input-label ">
              {show
                ? `₹${new Intl.NumberFormat("en-IN").format(Math.round(netPrice?.service_tax_and_levies))}`
                : "₹-----"}
            </Form.Text>
          </Col>
        </Row>
        <Row>
          <Col xs={12} sm={6} className="flex flex-col">
            <Form.Text className="input-label ">Fuel Surcharge</Form.Text>
          </Col>
          <Col xs={12} sm={6} className="items-start invoice">
            <Form.Text className="input-label ">
              {show
                ? `₹${new Intl.NumberFormat("en-IN").format(Math.round(netPrice?.fuel_surcharge))}`
                : "₹-----"}
            </Form.Text>
          </Col>
        </Row>
        {show && !!netPrice?.ssr_names?.length &&
          netPrice?.ssr_names?.map((_: any, index: number) => {
            return (
              <Row className="mt-2" key={index}>
                <Col xs={12} sm={6}>
                  <Form.Text className="input-label price-text">{netPrice?.ssr_names[index]}</Form.Text>
                </Col>
                <Col xs={12} sm={6}>
                  <Form.Text className="input-label price-text invoice ">
                    ₹{new Intl.NumberFormat("en-IN").format(Math.round(netPrice?.ssr_fares[index]))}
                  </Form.Text>
                </Col>
              </Row>
            );
          })}
        {!!netPrice?.discount && (
          <Row>
            <Col xs={12} sm={6} className="flex flex-col">
              <span className="text-base font-normal text-[#17a300]">Discount</span>
              <Form.Text className="input-label discount-text-font">({!!discountDescription ? discountDescription : Object?.keys(netPrice?.discount_category)?.join(', ')})</Form.Text>
            </Col>
            <Col xs={12} sm={6} className={"invoice"}>
              <span className="text-base font-normal text-[#17a300]">
                {show ? `-₹${new Intl.NumberFormat("en-IN").format(Math.round(netPrice?.discount))}` : "₹-----"}
              </span>
            </Col>
          </Row>
        )}
        <Row className="mt-0.5">
          <Col xs={12} sm={6}>
            <Form.Text className="input-label ">GST</Form.Text>
          </Col>
          <Col xs={12} sm={6} className={"invoice"}>
            <Form.Text className="input-label ">
              {show ? `₹${new Intl.NumberFormat("en-IN").format(Math.round(netPrice?.gst))}` : "₹-----"}
            </Form.Text>
          </Col>
        </Row>
        <div className="mt-4 border px-3 py-2">
          <div className={`flex items-center ${!viewDetail ? 'justify-between' : 'justify-end'}`}>
            {!viewDetail && <div>
              <div
                className="flex items-center gap-1 mt-2"
                style={{ fontSize: "13px", fontWeight: "500", lineHeight: "16.93px" }}
              >
                {currentItineraryDetails?.tripType === 'one_way' ? <OneWayTripIconSvg height={18} width={16}/> :<RoundTripIconSvg height={18} width={18}/>}
                <p className="my-0 mx-1">
                 {handleTripType(currentItineraryDetails?.tripType)} from : <span style={{ fontWeight: 400 }}>{currentItineraryDetails?.originPort} to {currentItineraryDetails?.destinationPort}</span>
                </p>
              </div>
              <div
                className="flex items-center gap-1 mt-2"
                style={{ fontSize: "13px", fontWeight: "500", lineHeight: "16.93px" }}
              >
                <MoonIconSvg fill="#7a7a7a" height={16} width={17} />
                <p className="my-0 mx-1">{currentItineraryDetails?.nightCount} Nights</p>
              </div>
              <div
                className="flex items-center gap-1 -ml-0.5  mt-2"
                style={{ fontSize: "13px", fontWeight: "500", lineHeight: "16.93px" }}
              >
                <ShipIconSvg fill="#7a7a7a" height={20} width={20} />
                <p className="my-0 ml-0.5 mr-1 text-capitalize">{currentItineraryDetails?.shipName?.toLowerCase()}</p>
              </div>
              <div
                className="flex items-center gap-1 mt-2"
                style={{ fontSize: "13px", fontWeight: "500", lineHeight: "16.93px" }}
              >
                <CalendarIconSvg fill="#7a7a7a" height={18} width={18} />
                <p className="my-0 mx-1">{dayjs(splitDate(currentItineraryDetails?.startTime)).format("DD MMM YYYY")} - {dayjs(splitDate(currentItineraryDetails?.endTime)).format("DD MMM YYYY")}</p>
              </div>
              {show && <div
                className="flex items-center gap-1 mt-2"
                style={{ fontSize: "13px", fontWeight: "500", lineHeight: "16.93px" }}
              >
                <UserIconSvg fill="#7a7a7a" height={18} width={18} />
                <p className="my-0 mx-1">{handleGuestCount().count} {handleGuestCount().count > 1 ? 'Guests' : 'Guest'}</p>
                <OverlayTrigger delay={{ hide: 0, show: 50 }} placement="bottom"
                  overlay={
                    <Tooltip>
                        {`Adult: ${handleGuestCount()?.adults}`}
                        <br />
                        {`Children: ${handleGuestCount()?.children}`}
                        <br />
                        {`Infant: ${handleGuestCount()?.infants}`}
                    </Tooltip>
                  }>
                  <span className="cursor-pointer">
                    <InfoIconSvg fill="#D0566E" />
                  </span>
                </OverlayTrigger>
              </div>}
            </div>}
            <div>
              {!!netPrice?.total && !!netPrice?.discount && (
                <div style={{ position: "relative", overflow: "hidden" }}>
                  <div
                    className="w-[calc(100%-1rem)]  h-[2px] bg-[#D8666F]"
                    style={{ position: "absolute", top: 10, transform: "rotate(-10deg)" }}
                  ></div>
                  <span
                    style={{
                      fontSize: "21px",
                      fontWeight: "500",
                      lineHeight: "27.34px",
                      textAlign: "left",
                      color: "#7A7A7A",
                    }}
                  >
                    {`₹${new Intl.NumberFormat("en-IN").format(Math.round(netPrice?.total))}`}
                  </span>
                </div>
              )}
              {!!netPrice?.total && (
                <div>
                  <p
                    className="mt-2"
                    style={{
                      fontSize: "24px",
                      fontWeight: "700",
                      lineHeight: "31.25px",
                      textAlign: "left",
                      color: "#D8666F",
                    }}
                  >
                    {`₹${new Intl.NumberFormat("en-IN").format(Math.round(netPrice?.total - netPrice?.discount))}`}
                  </p>
                </div>
              )}
              {!!netPrice?.total && (
                <div>
                  <span
                    style={{
                      fontSize: "20px",
                      fontWeight: "400",
                      lineHeight: "15.62px",
                      textAlign: "right",
                      color: "#D8666F",
                    }}
                  >
                    {!!netPrice?.discount ? 'Discount Price' : 'Total Price'}
                  </span>
                </div>
              )}
            </div>
          </div>
        </div>
        {!viewDetail && <div className="mt-4 p-1">
          {/* <p>
                    Show previous sent quotations
                    </p>
                    <p className="border-bottom d-inline">
                    Quotation-1
                    </p> */}
         <div className="flex justify-between items-center">
            <SpecialAddon
              show={show}
              handleSumbmit={(item: any) => {
                if (item?.length > 0) {
                  setPayloadObj({ ...payloadObj, special_request_ids: item });
                } else {
                  const newPayloadObj = { ...payloadObj };
                  newPayloadObj.special_request_ids = [];
                  setPayloadObj({ ...newPayloadObj });
                }
              }}
            />
            <div>
              <Button
                type="submit"
                className={" mx-1 my-2 mainBtn createBtn"}
                onClick={handlePreviewQuotation}
              >
                Preview Quotation
              </Button>
            </div>
          </div>
        </div>}
      </Card.Body>
      <ModalWrapper show={successModalState} handleClose={() => setSuccessModalState(false)} closeBtnVis={false}>
        <ItinerarySuccessModal
          setStepNumber={setStepNumber}
          currentItineraryDetails={currentItineraryDetails}
          quotation
          handleClose={() => setSuccessModalState(false)}
        />
      </ModalWrapper>
      <ModalWrapper show={priceModalState} handleClose={() => setPriceModalState(false)} closeBtnVis={false} clx={'min-w-[40vw] max-h-[90vh] overflow-auto'}>
        <h4 className="text-uppercase font-bold mb-4">Preview Quotation</h4>
        <PriceDetailModal priceData={netPrice} handleGuestCount={handleGuestCount} setSuccessModalState={setSuccessModalState} setPriceModalState={setPriceModalState} payloadObj={payloadObj} itineraryDetails={itineraryDetails}  specialPricingUpgradeOffer={specialPricingUpgradeOffer}/>
      </ModalWrapper>
    </Card>
  );
};
export default PriceDetail;
